import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import { QUESTIONNAIRE_YES_NO_ANSWERS } from "../../../../../../api/questionnaires/patientQuestionnaires/usePatientQuestionnaireAnswersMutation";
import { BaseOptions } from "../../../../shared/BaseOptions/BaseOptions";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { TextAutocomplete } from "../../../../shared/TextAutocomplete/TextAutocomplete";

export function AnswerChoices({
  isMulti,
  choices,
  reason,
  options,
  onChangeChoices,
  onChangeReason,
  useAutocomplete,
}) {
  var { tCommon } = useAppTranslation.Common();

  var onSelect = (nextOption) => {
    var add = (o) => {
      if (isMulti) {
        onChangeChoices([...choices, o]);
      } else {
        onChangeChoices([o]);
      }
    };

    var remove = (o) => {
      onChangeChoices(choices.filter((i) => i !== o));
    };

    if (choices.includes(nextOption)) {
      remove(nextOption);
    } else {
      add(nextOption);
    }
  };

  return (
    <div className={styles.root}>
      <BaseOptions options={options} value={choices} onSelect={onSelect} />
      {choices[0] === QUESTIONNAIRE_YES_NO_ANSWERS.yes && onChangeReason && (
        <TextAutocomplete
          name="reason"
          value={reason}
          placeholder={tCommon("fillPatientQuestionnaire.comment")}
          onChange={(e) => onChangeReason(e.target.value)}
          useAutocomplete={useAutocomplete}
        />
      )}
    </div>
  );
}

AnswerChoices.propTypes = {
  isMulti: PropTypes.bool,
  choices: PropTypes.arrayOf(PropTypes.string),
  reason: PropTypes.string,
  onChangeChoices: PropTypes.func,
  onChangeReason: PropTypes.func,
  useAutocomplete: PropTypes.bool,
};
